
export default class UploadRequest {
    constructor(config) {
        this.config = config;
    }

    generateFileName(uuid, fileName) {
        return `${uuid}.${fileName.split('.')[1]}`;
    }

    async uploadFile(file, uuid) {
        const { url, fields } = this.config;

        if (!fields?.key) {
            throw new Error(`upload config incomplete`);
        }

        fields.key = fields.key.replace('${filename}', this.generateFileName(uuid, file.name));// eslint-disable-line

        const body = new FormData();
        Object.keys(fields).forEach(key => body.append(key, fields[key]));
        body.append('file', file);

        //Empty header to prevent authentication by fetch
        const headers = { Authorization: '' };

        const response = await fetch(url, {
            method: 'POST',
            body,
            headers: headers,
            // Stop fetcher from sending authorization header
            auth: false
        })
        if (!response.ok) {
            throw new Error(`request on ${url} failed with ${response.status}`);
        };

        const { key } = fields;
        return key;

    }
}
